// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js"}[chunkId] + "-" + {"351":"fc2a0a0dfc6306530cbf","678":"83d9004fcd178dde5795"}[chunkId] + ".js";
};